
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/high",
      function () {
        return require("private-next-pages/learning/high.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/high"])
      });
    }
  